import React, { Component } from 'react';
import { View } from 'react-native';
export class Table extends Component {
  _renderChildren(props) {
    return React.Children.map(props.children, child => {
      if ( /*#__PURE__*/React.isValidElement(child)) {
        return /*#__PURE__*/React.cloneElement(child, props.borderStyle && child.type.displayName !== 'ScrollView' ? {
          borderStyle: props.borderStyle
        } : {});
      }
    });
  }

  render() {
    const {
      borderStyle
    } = this.props;
    const borderLeftWidth = borderStyle && borderStyle.borderWidth || 0;
    const borderBottomWidth = borderLeftWidth;
    const borderColor = borderStyle && borderStyle.borderColor || '#000';
    return /*#__PURE__*/React.createElement(View, {
      style: [this.props.style, {
        borderLeftWidth,
        borderBottomWidth,
        borderColor
      }]
    }, this._renderChildren(this.props));
  }

}
export class TableWrapper extends Component {
  _renderChildren(props) {
    return React.Children.map(props.children, child => /*#__PURE__*/React.cloneElement(child, props.borderStyle ? {
      borderStyle: props.borderStyle
    } : {}));
  }

  render() {
    const {
      style
    } = this.props;
    return /*#__PURE__*/React.createElement(View, {
      style: style
    }, this._renderChildren(this.props));
  }

}
//# sourceMappingURL=table.js.map